



























import { Component, Vue, Prop } from 'vue-property-decorator';
import { ProjectData, Organ } from '@/types';
import { isTencentCharityProject } from '@/business/helper';

@Component
export default class ProjectDesc extends Vue {
  @Prop() project!: ProjectData;
  @Prop() organ!: Organ;

  get isTencentProj() {
    return isTencentCharityProject(this.project.isNineProj);
  }

  public getLogoStyle(url: string) {
    return {
      backgroundSize: '100% 100%',
      backgroundImage: `url(${url})`,
    }
  }
}

